<template>
  <div id="videoDetail">
    <div class="video_wrap">
      <video
        class="video"
        :src="videoUrl"
        :poster="poster"
        ref="video"
        width="100%"
        height="100%"
        playsinline="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
         @click="videoPlay"
        @canplay="getDuration"
        @onplay="getDuration"
        @timeupdate="updateTime"
        @progress="getBuffer"
        @play="getPlay"
        @pause="getPause"
        @ended="playEnd"></video>
      <div class="btn" @click="videoPlay" v-if="!isPlay"></div>
    </div>
    <div class="info_wrap">
      <div class="names">
        <div class="name">{{name}}</div>
        <div class="time">{{time}}</div>
      </div>
      <div class="title">{{title}}</div>
    </div>
    <div class="silde_wrap">
      <div class="headimgs" v-if="headimg">
        <img class="headimg" :src="headimg" alt="">
      </div>
      <div class="btns" @click="goDown">
        <div class="icons">
          <img class="icon" src="../assets/img/icon_start.png" alt="">
        </div>
        <div class="num">{{playNum}}</div>
      </div>
      <div class="btns" @click="goDown">
        <div class="icons">
          <img class="icon" src="../assets/img/icon_xin.png" alt="">
        </div>
        <div class="num">{{zanNum}}</div>
      </div>
      <div class="btns" @click="goDown">
        <div class="icons">
          <img class="icon" src="../assets/img/icon_msg.png" alt="">
        </div>
        <div class="num">{{commentNum}}</div>
      </div>
      <div class="btns" @click="goDown">
        <div class="icons">
          <img class="icon" src="../assets/img/icon_share.png" alt="">
        </div>
        <div class="num">{{shareNum}}</div>
      </div>
    </div>
    <div class="controls_wrap" ref="lines" @click="jumpTime">
      <div class="lines"></div>
      <div class="line" :style="{width: lineScale + '%'}"></div>
      <div class="spot" :style="{left: lineScale + '%'}" @touchstart="dragSpot"></div>
      <transition name="fade">
        <div class="time_wrap" v-if="isDrag">{{videoTimeStamp}} / {{videoAllTimeStamp}}</div>
      </transition>
    </div>
    <div class="comment_wrap" v-if="commentShow" @click.self="commentShow = false">
      <div class="comment_conent">
        <div class="title">评论（{{commentNum}}）</div>
        <div class="wraps">
          <div class="comment_lists">
            <div class="list" v-for="(item, index) in comments" :key="index">
              <div class="infos">
                <div class="headimgs">
                  <img class="headimg" :src="item.userpic" alt="">
                </div>
                <div class="name">{{item.username }}</div>
              </div>
              <div class="detail">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "videoDetail",
  data() {
    return {
      // id: this.$route.query.id || '15391c51c059466ba8fe98cbf9d5a1c4',
      id: this.$route.query.id || '27a36b1a4c20465f824e7358f3e6adce',
      type: Number(this.$route.query.type) || 2, // 1 热门视频 2 国防号视频
      videoUrl: '',
      poster: '',
      name: '',
      time: '',
      title: '',
      headimg: 'http://file.xuexiguofang.com/526d2b5a8fea49f8ac2f38f20130156e.jpg',
      playNum: 0,
      zanNum: 0,
      shareNum: 0,
      commentNum: 0,
      videoTime: 0,
      videoTimeStamp: '00:00',
      videoAllTime: 0,
      videoAllTimeStamp: '00:00',
      lineScale: 0,
      isPlay: false,
      isDrag: false,
      comments: [],
      commentShow: false
    };
  },
  watch:{
    isPlay () {
      if (this.isPlay) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    }
  },
  mounted () {
    this.getInfo();
    // this.getComment();
  },
  methods: {
    getInfo () {
      if (this.type === 1) {
        this.axios.get('/xxgf-api/videoHot/getVideoById?videoid=' + this.id)
          .then(({data}) => {
            if (data.code === 200) {
              this.videoUrl = data.data.videopic;
              this.poster = data.data.videophotopic;
              this.name = data.data.videoname;
              this.title = data.data.videotitle;
              this.time = data.data.createtime.split(' ')[0];
              this.playNum = data.data.browse < 10000 ? data.data.browse : (data.data.browse / 10000).toFixed(1) + 'W';
              this.zanNum = data.data.givethethumbsup < 10000 ? data.data.givethethumbsup : (data.data.givethethumbsup / 10000).toFixed(1) + 'W';
              this.shareNum = data.data.sharevolume < 10000 ? data.data.sharevolume : (data.data.sharevolume / 10000).toFixed(1) + 'W';
              this.commentNum = data.data.comment < 10000 ? data.data.comment : (data.data.comment / 10000).toFixed(1) + 'W';
            }
          })
        this.axios.post('/xxgf-api/videoHot/videoShare', {
          id: this.id
        })
          .then(({data}) => {})
      } else {
        this.axios.post('/xxgf-api/api/nationaldefense/shareVedioDetail', {id: this.id})
          .then(({data}) => {
            if (data.code === 200) {
              this.videoUrl = data.data.vedioUrl;
              this.poster = data.data.coverImg;
              this.name = data.data.name;
              this.title = data.data.title;
              this.headimg = data.data.logoUrl;
              this.time = data.data.createTime.split(' ')[0];
              this.playNum = data.data.readingVolume < 10000 ? data.data.readingVolume : (data.data.readingVolume / 10000).toFixed(1) + 'W';
              this.zanNum = data.data.likeNum < 10000 ? data.data.likeNum : (data.data.likeNum / 10000).toFixed(1) + 'W';
              this.shareNum = data.data.collectionNum < 10000 ? data.data.collectionNum : (data.data.collectionNum / 10000).toFixed(1) + 'W';
              this.commentNum = data.data.commentNum < 10000 ? data.data.commentNum : (data.data.commentNum / 10000).toFixed(1) + 'W';
            }
          })
      }
    },
    getComment () {
      if (this.type === 1) {
        this.axios.get('/xxgf-api/videoHot/getVideoComments', {
          params: {
            videoid: this.id,
            pageNum: 1,
            pageSize: 20
          }
        })
          .then(({data}) => {
            if (data.code === 200) {
              this.comments = data.rows[0].videoCommentList;
            }
          })
      } else {
        this.axios.get('/xxgf-api/homepage/getTopCommentlist', {
          params: {
            serviceId: this.id,
            pageNum: 1,
            pageSize: 20,
            type: 13
          }
        })
          .then(({data}) => {
            if (data.code === 200) {
              this.comments = data.rows;
            }
          })
      }
    },
    goDown () {
      this.$router.push('/download');
    },
    // 视频播放
    videoPlay () {
      this.isPlay = !this.isPlay;
    },
    getPlay () {
      this.isPlay = true;
    },
    getPause () {
      this.isPlay = false;
    },
    // 初始化获取video的总时长
    getDuration(e, num) {
      let allTime;
      if (num) {
        allTime = num;
      } else {
        allTime = this.$refs.video.duration || 0;
      }
      let hour = parseInt(allTime / 3600);
      let min = parseInt(allTime / 60 % 60);
      let sec = parseInt(allTime % 60);
      hour = this.numberAddZero(hour);
      min = this.numberAddZero(min);
      sec = this.numberAddZero(sec);
      this.videoAllTime = allTime;
      if (hour === '00') {
        this.videoAllTimeStamp = `${min}:${sec}`;
      } else {
        this.videoAllTimeStamp = `${hour}:${min}:${sec}`;
      }
    },
    updateTime(e) {
      //获取选择播放的video当前播放时间
      this.videoTime = e.target.currentTime;
      if (this.videoAllTime === 0) {
        this.getDuration(e.target.duration);
      }
      let time = e.target.currentTime;
      if (this.isDrag) return false;
      let hour = parseInt(time / 3600);
      let min = parseInt(time / 60 % 60);
      let sec = parseInt(time % 60);
      hour = this.numberAddZero(hour);
      min = this.numberAddZero(min);
      sec = this.numberAddZero(sec);
      if (hour === '00') {
        this.videoTimeStamp = `${min}:${sec}`;
      } else {
        this.videoTimeStamp = `${hour}:${min}:${sec}`;
      }
      this.countLineScale();
    },
    // 获取缓存长度
    getBuffer (e) {
      let buffer = e.target.buffered;
      for (var i = 0; i < buffer.length; i++) {
        // 寻找当前时间之后最近的点
        if (buffer.start(buffer.length - 1 - i) < e.target.currentTime) {
          let bufferedLength = (buffer.end(buffer.length - 1 - i) / this.videoAllTime) * 100;
          this.bufferedLength = bufferedLength;
          break;
        }
      }
    },
    // 视频结束播放事件
    playEnd () {
      this.isPlay = false;
      this.videoTime = 0;
      this.videoTimeStamp = '00:00';
      this.$refs.video.currentTime = 0;
    },
    // 计算进度条
    countLineScale () {
      if (this.isDrag) return false;
      this.lineScale = this.videoTime / this.videoAllTime * 100;
    },
    // 跳转至对应的时间
    jumpTime (e) {
      let scale = e.offsetX / this.$refs.lines.offsetWidth;
      let time = parseInt(scale * this.videoAllTime);
      this.videoTime = time;
      this.$refs.video.currentTime = time;
      this.countLineScale();
      this.isPlay = true;
      this.isDrag = true;
      setTimeout(() => {
        this.isDrag = false;
      }, 1000);
    },
    // 拖拽
    dragSpot (e) {
      // e.preventDefault();
      let time;
      let scale;
      this.isDrag = true;
      document.ontouchmove = (e) => {
        // if (e.target.className === 'spot') return false;
        scale = e.touches[0].pageX / this.$refs.lines.offsetWidth;
        this.lineScale = scale * 100;
        let time = this.videoAllTime * scale;
        let hour = parseInt(time / 3600);
        let min = parseInt(time / 60 % 60);
        let sec = parseInt(time % 60);
        hour = this.numberAddZero(hour);
        min = this.numberAddZero(min);
        sec = this.numberAddZero(sec);
        if (hour === '00') {
          this.videoAllTimeStamp = `${min}:${sec}`;
        } else {
          this.videoAllTimeStamp = `${hour}:${min}:${sec}`;
        }
      };
      document.ontouchend = () => {
        document.ontouchmove = null;
        document.ontouchend = null;
        this.isDrag = false;
        time = parseInt(scale * this.videoAllTime);
        this.$refs.video.currentTime = time;
      };
    },
  }
};
</script>

<style lang="scss">
#videoDetail {
  width: 100%;
  height: 100%;
  background:#000;
  padding-bottom:120px;
  position:relative;
  .video_wrap{
    width:100%;
    height:100%;
    position:relative;
    .video{
      width:100%;
      height:100%;
    }
    .btn{
      width:88px;
      height:88px;
      background:url('../assets/img/icon_start.png') no-repeat 0 0 / 100% 100%;
      position:absolute;
      left:50%;
      top:50%;
      transform: translate(-50%, -50%);
      opacity: 0.8;
    }
  }
  .info_wrap{
    color:#fff;
    width:400px;
    position: absolute;
    left:45px;
    bottom:230px;
    z-index:2;
    .names{
      display:flex;
      align-items: center;
      .name{
        font-size:28px;
        margin-right:20px;
      }
      .time{
        font-size:22px;
      }
    }
    .title {
      font-size:22px;
      line-height:40px;
    }
  }
  .silde_wrap{
    position: absolute;
    right:45px;
    bottom:200px;
    z-index:2;
    width:88px;
    .headimgs{
      width:88px;
      height:88px;
      border-radius: 50%;
      overflow: hidden;
      margin-bottom:30px;
      .headimg{
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .btns{
      text-align:center;
      .icons{
        margin: 20px auto 0;
        width:68px;
        height:68px;
        .icon{
          width:68px;
          height:68px;
        }
      }
      .num{
        font-size:24px;
        color:#fff;
      }
    }
  }
  .controls_wrap{
    width:100%;
    height:50px;
    position:absolute;
    left:0;
    bottom:130px;
    z-index:2;
    .lines{
      width:100%;
      height:1PX;
      background:rgba($color: #fff, $alpha: 0.4);
      position:absolute;
      top:50%;
      left:0;
      z-index:2;
    }
    .line{
      height:1PX;
      background:#fff;
      position:absolute;
      top:50%;
      left:0;
      z-index:3;
    }
    .spot{
      position:absolute;
      width:16px;
      height:16px;
      background:#fff;
      border-radius: 50%;
      top:50%;
      margin-top:-8px;
      margin-left:-8px;
      z-index:5;
    }
    .time_wrap{
      height:55px;
      padding:0 30px;
      background:rgba($color: #000000, $alpha: 0.2);
      font-size:28px;
      color:#fff;
      border-radius: 20px;
      position: absolute;
      top:-55px;
      left:50%;
      transform: translateX(-50%);
    }
  }
  .comment_wrap{
    width:100%;
    height:100%;
    background:rgba($color: #000000, $alpha: 0.6);
    position: absolute;
    left:0;
    top:0;
    z-index:2;
    .comment_conent{
      width:100%;
      height:920px;
      padding:0 30px 150px;
      background:#fff;
      border-radius: 10px 10px 0 0;
      position: absolute;
      left:0;
      bottom:0px;
      .title{
        line-height:90px;
        font-size:32px;
      }
      .wraps{
        height:calc(100% - 90px);
        overflow-y: scroll;
        overflow-x: hidden;
        .comment_lists {
          .list{
            margin-bottom:30px;
            .infos{
              display:flex;
              align-items: center;
              .headimgs{
                width:80px;
                height:80px;
                border-radius: 50%;
                overflow: hidden;
                margin-right:20px;
                .headimg{
                  width:100%;
                  height:100%;
                  object-fit: cover;
                }
              }
              .name{
                font-size:36px;
                font-weight: bold;
              }
            }
            .detail{
              color:#666;
              font-size:32px;
              padding-left:100px;
            }
          }
        }
      }
    }
  }
}
</style>
